import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { siteConfig } from '@/mocks/siteData';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <h3 className="font-heading text-lg font-semibold text-white mb-4">{siteConfig.name}</h3>
              <p className="text-sm text-background-400 leading-relaxed">
                {siteConfig.tagline}
              </p>
              <p className="text-sm text-background-400 leading-relaxed mt-2">
                你打开优质社交圈子的最佳切入点。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-white mb-4">内容分类</h4>
              <ul className="flex flex-col gap-2.5">
                {categories.map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-white transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-white mb-4">快速链接</h4>
              <ul className="flex flex-col gap-2.5">
                <li>
                  <Link to="/" className="text-sm text-background-400 hover:text-white transition-colors">首页</Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-white transition-colors">关于我们</Link>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-400 hover:text-white transition-colors">隐私政策</a>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-400 hover:text-white transition-colors">使用条款</a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-white mb-4">联系我们</h4>
              <ul className="flex flex-col gap-2.5">
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-mail-line text-base"></i>
                  <span>{siteConfig.email}</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-wechat-line text-base"></i>
                  <span>jiejiefriends</span>
                </li>
              </ul>
              <div className="flex items-center gap-3 mt-4">
                <a href={siteConfig.socialLinks.wechat} className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-background-700 text-background-300 hover:text-white transition-colors" aria-label="微信" rel="nofollow">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href={siteConfig.socialLinks.weibo} className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-background-700 text-background-300 hover:text-white transition-colors" aria-label="微博" rel="nofollow">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href={siteConfig.socialLinks.xiaohongshu} className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-background-700 text-background-300 hover:text-white transition-colors" aria-label="小红书" rel="nofollow">
                  <i className="ri-booklet-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-background-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} {siteConfig.name}. All Rights Reserved.
            </p>
            <p className="text-xs text-background-500">
              以真诚为本 · 科学导向 · 实操落地 · 温暖陪伴
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}